import { Dispatch, GetState } from "common/types";

import { fetchMySchoolInfoAndPushValuesToDataLayer } from "seneca-common/features/schools/service/utils";
import { getRegion, signInSuccess } from "seneca-common/features/user/state";
import { analyticsLogSignIn } from "seneca-common/utils/senecaAnalytics";

import { fetchUserInfo } from "features/user/actions/userInfo";
import { setUserAsSignedUpBefore } from "features/user/utils/signedUpBefore";

import { setRegionPreference } from "../../../preferences";
import { fetchAdditionalUserInfoOnSignIn } from "../../signInWithEmailAndPassword";
import { reconcileData } from "../../utils";

type ArgsSignIn = {
  region: string | null | undefined;
  onSignInSuccess?: () => void;
  userId: string;
};

export default function proceedUserSignIn({
  onSignInSuccess,
  region,
  userId
}: ArgsSignIn) {
  return async function (dispatch: Dispatch, getState: GetState) {
    try {
      await Promise.all([
        fetchMySchoolInfoAndPushValuesToDataLayer(),
        dispatch(fetchUserInfo())
      ]);
    } catch (err: any) {}

    await dispatch(reconcileData());

    setUserAsSignedUpBefore();

    const persistedRegion = getRegion(getState());

    if (!persistedRegion && region) {
      dispatch(setRegionPreference(region));
    }

    dispatch(signInSuccess(userId));
    await fetchAdditionalUserInfoOnSignIn(dispatch);

    onSignInSuccess && onSignInSuccess();

    analyticsLogSignIn(getState());
  };
}
